import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Instagram, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function InstagramButton({ compact = false }) {
  const { user, setUser } = useAuth();
  const { data: settings } = useQuery({
    queryKey: ["settings-public"],
    queryFn: async () => (await api.get("/settings/public")).data,
  });
  const url = settings?.rules?.instagram_url;
  if (!url) return null;

  const unlocked = user?.badges?.some((b) => b.key === "dinamiko");

  const onClick = async () => {
    window.open(url, "_blank", "noopener,noreferrer");
    if (unlocked) return;
    try {
      const { data } = await api.post("/trophies/instagram");
      if (data.unlocked) {
        toast.success("📷 TROFEO SBLOCCATO! Ora sei Dinamiko/a!", {
          description: "Hai visitato la pagina ufficiale di Dinamika APS. Benvenuto/a nella community!",
          duration: 6000,
        });
        const me = await api.get("/auth/me");
        setUser(me.data);
      }
    } catch {
      // sblocco trofeo non critico
    }
  };

  if (unlocked) {
    return (
      <span
        data-testid="instagram-unlocked"
        className="inline-flex items-center gap-1.5 font-body-sport text-[11px] font-bold tracking-widest text-[#22C55E] border border-[#22C55E]/40 bg-[#22C55E]/10 rounded-full px-3 py-1.5"
      >
        <CheckCircle2 className="w-3.5 h-3.5" /> ✓ Già Dinamiko/a!
      </span>
    );
  }

  return (
    <button
      data-testid="instagram-button"
      onClick={onClick}
      className={`inline-flex flex-col items-start gap-0.5 rounded-xl border border-[#E1306C]/50 bg-gradient-to-r from-[#833AB4]/20 via-[#E1306C]/20 to-[#F77737]/20 px-4 py-2.5 min-h-[48px] hover:border-[#E1306C] transition-colors ${compact ? "" : ""}`}
    >
      <span className="flex items-center gap-2 font-body-sport font-bold text-xs tracking-widest text-white uppercase">
        <Instagram className="w-4 h-4 text-[#E1306C]" /> Seguici su Instagram
      </span>
      <span className="text-[10px] text-gray-400">Clicca per sbloccare il badge speciale!</span>
    </button>
  );
}
